import React, { useEffect, useState } from "react";
import "../Dashboard/Dashboard.css";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../Loader/Loader";
import { useParams } from "react-router-dom";
import styles from "./VendorDashboard.module.scss";
import { formatIndianCurrency } from "../../../utils/utils";
import Skeleton from "react-loading-skeleton";
import { animateScroll as scroll } from "react-scroll";
import imgNotFound from "../../../assets/images/single-image.png";
import Slider from "react-slick/lib/slider";

const VendorDashboard = ({ text }) => {
  var hotelSettings = {
    speed: 500,
    centerMode: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          infinite: false,
        },
      },
      {
        breakpoint: 630,
        settings: {
          infinite: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 450,
        settings: {
          infinite: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 374,
        settings: {
          infinite: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  const [loader, setLoader] = useState(false);
  const [overviewData, setOverviewData] = useState([]);
  const [allProperties, setAllProperties] = useState([]);
  const navigate = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const vendorToken = localStorage.getItem("token");

  useEffect(() => {
    if (userDetails.accountId) {
      getProperties(userDetails.accountId);
    }
  }, [userDetails.id]);

  const { id } = useParams();

  const fetchVendorOverview = () => {
    const requestOptions = {
      // myHeaders.append("key", "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1");
      headers: {
        "Content-Type": "application/json",
        key: "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      method: "GET",
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/v1/vendor/get-dashboard-detail/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setOverviewData(result);
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchVendorOverview();
  }, []);

  const getProperties = async () => {
    setLoader(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${vendorToken}`);
      myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodations/fetch`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const result = await response.json();
      setAllProperties(result?.hotels);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching accommodations:", error);
      setLoader(false);
    }
  };

  return (
    <section className="w-full">
      <div className="mt-10">
        <div className={styles.agent_dashboard_heading_sec}>
          <h4 className={styles.agent_dashboard_new_heading}>Dashboard</h4>
          <div className={styles.property_details_flex}>
            <div className={styles.property_details}>
              <span className="font-3 font_12">
                {overviewData?.data?.today_average_revenue}
              </span>
              <div className="flex align_items_center justify_content_between">
                <h6>Today's Average Revenue </h6>
                <svg
                  width="31"
                  height="30"
                  viewBox="0 0 31 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.914062"
                    y="0.25"
                    width="29.5"
                    height="29.5"
                    rx="14.75"
                    strokeWidth="0.5"
                  />
                  <mask
                    id="mask0_6855_7898"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="2"
                    y="2"
                    width="27"
                    height="26"
                  >
                    <rect
                      x="15.6641"
                      y="27.728"
                      width="18"
                      height="18"
                      transform="rotate(-135 15.6641 27.728)"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_6855_7898)">
                    <path
                      d="M18.621 12.5718L12.4805 18.7124C12.405 18.7878 12.3166 18.8256 12.2153 18.8256C12.114 18.8256 12.0256 18.7878 11.9501 18.7124C11.8747 18.6369 11.8369 18.5485 11.8369 18.4472C11.8369 18.3459 11.8747 18.2575 11.9501 18.182L18.0907 12.0415L12.3224 12.0413C12.2191 12.0414 12.1312 12.0076 12.0587 11.9399C11.9863 11.8723 11.9501 11.78 11.9501 11.6629C11.9522 11.5481 11.986 11.4569 12.0516 11.3892C12.1172 11.3215 12.2085 11.2877 12.3254 11.2877L18.775 11.2877C18.8676 11.2877 18.9474 11.3025 19.0143 11.3321C19.0813 11.3617 19.1433 11.405 19.2004 11.4621C19.2575 11.5192 19.3008 11.5812 19.3304 11.6482C19.36 11.7151 19.3748 11.7949 19.3748 11.8875L19.3748 18.3371C19.3748 18.4363 19.341 18.5232 19.2733 18.5977C19.2056 18.6721 19.1144 18.7103 18.9996 18.7124C18.8825 18.7124 18.7902 18.6785 18.7226 18.6109C18.6549 18.5432 18.6211 18.4509 18.6212 18.334L18.621 12.5718Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </svg>
              </div>

              {/* <h2>{overviewData?.data?.today_average_revenue}</h2> */}
              {/* <span>For Last 7 Days: 100 Bookings</span> */}
            </div>
            <div className={styles.property_details}>
              <span className="font-3 font_12">
                {overviewData?.data?.today_checkin}
              </span>
              <div className="flex align_items_center justify_content_between">
                {" "}
                <h6>Today's Checkin</h6>{" "}
                <svg
                  width="31"
                  height="30"
                  viewBox="0 0 31 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.914062"
                    y="0.25"
                    width="29.5"
                    height="29.5"
                    rx="14.75"
                    strokeWidth="0.5"
                  />
                  <mask
                    id="mask0_6855_7898"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="2"
                    y="2"
                    width="27"
                    height="26"
                  >
                    <rect
                      x="15.6641"
                      y="27.728"
                      width="18"
                      height="18"
                      transform="rotate(-135 15.6641 27.728)"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_6855_7898)">
                    <path
                      d="M18.621 12.5718L12.4805 18.7124C12.405 18.7878 12.3166 18.8256 12.2153 18.8256C12.114 18.8256 12.0256 18.7878 11.9501 18.7124C11.8747 18.6369 11.8369 18.5485 11.8369 18.4472C11.8369 18.3459 11.8747 18.2575 11.9501 18.182L18.0907 12.0415L12.3224 12.0413C12.2191 12.0414 12.1312 12.0076 12.0587 11.9399C11.9863 11.8723 11.9501 11.78 11.9501 11.6629C11.9522 11.5481 11.986 11.4569 12.0516 11.3892C12.1172 11.3215 12.2085 11.2877 12.3254 11.2877L18.775 11.2877C18.8676 11.2877 18.9474 11.3025 19.0143 11.3321C19.0813 11.3617 19.1433 11.405 19.2004 11.4621C19.2575 11.5192 19.3008 11.5812 19.3304 11.6482C19.36 11.7151 19.3748 11.7949 19.3748 11.8875L19.3748 18.3371C19.3748 18.4363 19.341 18.5232 19.2733 18.5977C19.2056 18.6721 19.1144 18.7103 18.9996 18.7124C18.8825 18.7124 18.7902 18.6785 18.7226 18.6109C18.6549 18.5432 18.6211 18.4509 18.6212 18.334L18.621 12.5718Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </svg>{" "}
              </div>
              {/* <h2>₹50,000</h2>
            <span>For Last 7 Days: ₹50,000 Payout</span> */}
            </div>
          </div>
        </div>
        {/* <div className="booking_commission_data">
            <div className="rates_table">
              <h4 className="text-left">Recent Bookings</h4>
              <table className=" mt-10 recent_bookings_table">
                <thead>
                  <tr>
                    <th>Booking ID</th>
                    <th>Product</th>
                    <th>Status</th>
                    <th>Net Amt.</th>
                  </tr>
                  <tr>
                    <td className="booking_id">#12345</td>
                    <td>
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_7000_4106"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="19"
                        >
                          <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_7000_4106)">
                          <path
                            d="M2.91269 15.9329C2.59644 15.9329 2.3275 15.8221 2.10587 15.6004C1.88425 15.3787 1.77344 15.1097 1.77344 14.7934V3.94711C1.77344 3.63086 1.88425 3.36192 2.10587 3.1403C2.3275 2.91867 2.59644 2.80786 2.91269 2.80786H7.759C8.07525 2.80786 8.34419 2.91867 8.56581 3.1403C8.78744 3.36192 8.89825 3.63086 8.89825 3.94711V5.80786H15.0859C15.4022 5.80786 15.6711 5.91867 15.8927 6.1403C16.1144 6.36192 16.2252 6.63086 16.2252 6.94711V14.7934C16.2252 15.1097 16.1144 15.3787 15.8927 15.6004C15.6711 15.8221 15.4022 15.9329 15.0859 15.9329H2.91269ZM2.89825 14.8079H7.77344V12.9329H2.89825V14.8079ZM2.89825 11.8079H7.77344V9.93286H2.89825V11.8079ZM2.89825 8.80786H7.77344V6.93286H2.89825V8.80786ZM2.89825 5.80786H7.77344V3.93286H2.89825V5.80786ZM8.89825 14.8079H15.1004V6.93286H8.89825V14.8079ZM11.1051 9.93286C10.9458 9.93286 10.8121 9.87892 10.7043 9.77105C10.5965 9.66317 10.5426 9.52949 10.5426 9.36999C10.5426 9.21061 10.5965 9.07705 10.7043 8.9693C10.8121 8.86167 10.9458 8.80786 11.1051 8.80786H12.7493C12.9087 8.80786 13.0422 8.8618 13.15 8.96967C13.2579 9.07742 13.3118 9.21105 13.3118 9.37055C13.3118 9.53005 13.2579 9.66361 13.15 9.77124C13.0422 9.87899 12.9087 9.93286 12.7493 9.93286H11.1051ZM11.1051 12.9329C10.9458 12.9329 10.8121 12.8789 10.7043 12.771C10.5965 12.6632 10.5426 12.5295 10.5426 12.37C10.5426 12.2106 10.5965 12.077 10.7043 11.9693C10.8121 11.8617 10.9458 11.8079 11.1051 11.8079H12.7493C12.9087 11.8079 13.0422 11.8618 13.15 11.9697C13.2579 12.0774 13.3118 12.211 13.3118 12.3705C13.3118 12.53 13.2579 12.6636 13.15 12.7712C13.0422 12.879 12.9087 12.9329 12.7493 12.9329H11.1051Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                      Hotel
                    </td>
                    <td>
                      {" "}
                      <span className="confirm_status">confirmed</span>
                    </td>
                    <td>₹74,880.00</td>
                  </tr>
                  <tr>
                    <td className="booking_id">#12345</td>
                    <td>
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_7000_4652"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="19"
                        >
                          <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_7000_4652)">
                          <path
                            d="M5.21631 16.0399C4.82701 16.0399 4.49376 15.9029 4.21657 15.6287C3.93938 15.3546 3.80078 15.025 3.80078 14.64V6.3595C3.80078 5.97447 3.93938 5.64489 4.21657 5.37073C4.49376 5.09658 4.82701 4.95951 5.21631 4.95951H6.84266V3.50008C6.84266 3.11506 6.98126 2.78547 7.25845 2.51132C7.53565 2.23717 7.86889 2.1001 8.25819 2.1001H9.64337C10.0327 2.1001 10.3659 2.23717 10.6431 2.51132C10.9203 2.78547 11.0589 3.11506 11.0589 3.50008V4.95951H12.6853C13.0746 4.95951 13.4078 5.09658 13.685 5.37073C13.9622 5.64489 14.1008 5.97447 14.1008 6.3595V14.64C14.1008 15.025 13.9622 15.3546 13.685 15.6287C13.4078 15.9029 13.0746 16.0399 12.6853 16.0399V16.1292C12.6853 16.3189 12.6177 16.4805 12.4826 16.614C12.3477 16.7476 12.1843 16.8144 11.9925 16.8144C11.8008 16.8144 11.6374 16.7476 11.5025 16.614C11.3674 16.4805 11.2999 16.3189 11.2999 16.1292V16.0399H6.60169V16.1292C6.60169 16.3189 6.53415 16.4805 6.39908 16.614C6.26413 16.7476 6.10081 16.8144 5.90909 16.8144C5.71725 16.8144 5.55386 16.7476 5.41892 16.614C5.28384 16.4805 5.21631 16.3189 5.21631 16.1292V16.0399ZM5.21631 14.8783H12.6853C12.7555 14.8783 12.8132 14.856 12.8585 14.8113C12.9037 14.7666 12.9262 14.7095 12.9262 14.64V6.3595C12.9262 6.28993 12.9037 6.23281 12.8585 6.18815C12.8132 6.14349 12.7555 6.12116 12.6853 6.12116H5.21631C5.1461 6.12116 5.08835 6.14349 5.04306 6.18815C4.99791 6.23281 4.97533 6.28993 4.97533 6.3595V14.64C4.97533 14.7095 4.99791 14.7666 5.04306 14.8113C5.08835 14.856 5.1461 14.8783 5.21631 14.8783ZM7.42955 7.19356C7.26315 7.19356 7.12371 7.24919 7.01121 7.36046C6.89885 7.47185 6.84266 7.60982 6.84266 7.77439V13.2251C6.84266 13.3896 6.89898 13.5276 7.0116 13.639C7.12423 13.7503 7.26374 13.8059 7.43013 13.8059C7.59666 13.8059 7.7361 13.7503 7.84847 13.639C7.96096 13.5276 8.01721 13.3896 8.01721 13.2251V7.77439C8.01721 7.60982 7.9609 7.47185 7.84827 7.36046C7.73565 7.24919 7.59607 7.19356 7.42955 7.19356ZM10.4714 7.19356C10.3049 7.19356 10.1655 7.24919 10.0531 7.36046C9.9406 7.47185 9.88435 7.60982 9.88435 7.77439V13.2251C9.88435 13.3896 9.94066 13.5276 10.0533 13.639C10.1659 13.7503 10.3055 13.8059 10.472 13.8059C10.6384 13.8059 10.7779 13.7503 10.8904 13.639C11.0027 13.5276 11.0589 13.3896 11.0589 13.2251V7.77439C11.0589 7.60982 11.0026 7.47185 10.89 7.36046C10.7773 7.24919 10.6378 7.19356 10.4714 7.19356ZM8.01721 4.95951H9.88435V3.50008C9.88435 3.43051 9.86177 3.3734 9.81662 3.32874C9.77146 3.28408 9.71372 3.26175 9.64337 3.26175H8.25819C8.18785 3.26175 8.1301 3.28408 8.08494 3.32874C8.03979 3.3734 8.01721 3.43051 8.01721 3.50008V4.95951Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </svg>
                      Holiday
                    </td>
                    <td>
                      {" "}
                      <span className="confirm_status">confirmed</span>
                    </td>
                    <td>₹74,880.00</td>
                  </tr>
                  <tr>
                    <td className="booking_id">#12345</td>
                    <td>
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_7000_4658"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="19"
                        >
                          <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_7000_4658)">
                          <path
                            d="M5.87025 12.6298L10.6731 11.1731L12.1297 6.37025L7.32694 7.82694L5.87025 12.6298ZM8.99831 10.4808C8.72544 10.4808 8.49406 10.3853 8.30419 10.1941C8.11419 10.0031 8.01919 9.77119 8.01919 9.49831C8.01919 9.22544 8.11475 8.99406 8.30587 8.80419C8.49688 8.61419 8.72881 8.51919 9.00169 8.51919C9.27456 8.51919 9.50594 8.61475 9.69581 8.80587C9.88581 8.99688 9.98081 9.22881 9.98081 9.50169C9.98081 9.77456 9.88525 10.0059 9.69413 10.1958C9.50313 10.3858 9.27119 10.4808 8.99831 10.4808ZM9.00131 16.625C8.01581 16.625 7.0895 16.438 6.22237 16.064C5.35525 15.69 4.601 15.1824 3.95962 14.5413C3.31825 13.9002 2.81044 13.1463 2.43619 12.2795C2.06206 11.4128 1.875 10.4867 1.875 9.50131C1.875 8.51581 2.062 7.5895 2.436 6.72237C2.81 5.85525 3.31756 5.101 3.95869 4.45962C4.59981 3.81825 5.35375 3.31044 6.2205 2.93619C7.08725 2.56206 8.01331 2.375 8.99869 2.375C9.98419 2.375 10.9105 2.562 11.7776 2.936C12.6448 3.31 13.399 3.81756 14.0404 4.45869C14.6818 5.09981 15.1896 5.85375 15.5638 6.7205C15.9379 7.58725 16.125 8.51331 16.125 9.49869C16.125 10.4842 15.938 11.4105 15.564 12.2776C15.19 13.1448 14.6824 13.899 14.0413 14.5404C13.4002 15.1818 12.6463 15.6896 11.7795 16.0638C10.9128 16.4379 9.98669 16.625 9.00131 16.625ZM9 15.5C10.6672 15.5 12.0841 14.9168 13.2504 13.7504C14.4168 12.5841 15 11.1672 15 9.5C15 7.83275 14.4168 6.41594 13.2504 5.24956C12.0841 4.08319 10.6672 3.5 9 3.5C7.33275 3.5 5.91594 4.08319 4.74956 5.24956C3.58319 6.41594 3 7.83275 3 9.5C3 11.1672 3.58319 12.5841 4.74956 13.7504C5.91594 14.9168 7.33275 15.5 9 15.5Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                      Activity
                    </td>
                    <td>
                      {" "}
                      <span className="active_status">ACTIVE</span>
                    </td>
                    <td>₹74,880.00</td>
                  </tr>
                  <tr>
                    <td className="booking_id">#12345</td>
                    <td>
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_7000_4664"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="19"
                        >
                          <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_7000_4664)">
                          <path
                            d="M4.21144 14.375V15.0817C4.21144 15.3021 4.13425 15.4894 3.97987 15.6436C3.8255 15.7979 3.638 15.875 3.41737 15.875C3.19687 15.875 3.00969 15.7979 2.85581 15.6436C2.70194 15.4894 2.625 15.3021 2.625 15.0817V9.79138C2.625 9.7135 2.63006 9.63562 2.64019 9.55775C2.65031 9.47987 2.66731 9.40525 2.69119 9.33388L4.03425 5.53662C4.12413 5.2665 4.287 5.04706 4.52288 4.87831C4.75875 4.70944 5.02275 4.625 5.31487 4.625H12.6851C12.9773 4.625 13.2413 4.70944 13.4771 4.87831C13.713 5.04706 13.8759 5.2665 13.9658 5.53662L15.3088 9.33388C15.3327 9.40525 15.3497 9.47987 15.3598 9.55775C15.3699 9.63562 15.375 9.7135 15.375 9.79138V15.0817C15.375 15.3021 15.2978 15.4894 15.1434 15.6436C14.9889 15.7979 14.8014 15.875 14.5809 15.875C14.3603 15.875 14.1731 15.7979 14.0192 15.6436C13.8654 15.4894 13.7886 15.3021 13.7886 15.0817V14.375H4.21144ZM4.20581 8.43275H13.7942L12.9058 5.9015C12.8866 5.85338 12.8577 5.81612 12.8192 5.78975C12.7807 5.76325 12.735 5.75 12.6821 5.75H5.31787C5.265 5.75 5.21931 5.76325 5.18081 5.78975C5.14231 5.81612 5.11344 5.85338 5.09419 5.9015L4.20581 8.43275ZM5.59781 12.3847C5.87069 12.3847 6.10212 12.2891 6.29212 12.098C6.482 11.907 6.57694 11.6751 6.57694 11.4022C6.57694 11.1293 6.48144 10.8979 6.29044 10.7079C6.09931 10.518 5.86731 10.4231 5.59444 10.4231C5.32156 10.4231 5.09019 10.5186 4.90031 10.7096C4.71031 10.9007 4.61531 11.1327 4.61531 11.4056C4.61531 11.6784 4.71088 11.9098 4.902 12.0997C5.093 12.2897 5.32494 12.3847 5.59781 12.3847ZM12.4056 12.3847C12.6784 12.3847 12.9098 12.2891 13.0997 12.098C13.2897 11.907 13.3847 11.6751 13.3847 11.4022C13.3847 11.1293 13.2891 10.8979 13.098 10.7079C12.907 10.518 12.6751 10.4231 12.4022 10.4231C12.1293 10.4231 11.8979 10.5186 11.7079 10.7096C11.518 10.9007 11.4231 11.1327 11.4231 11.4056C11.4231 11.6784 11.5186 11.9098 11.7096 12.0997C11.9007 12.2897 12.1327 12.3847 12.4056 12.3847ZM3.75 13.25H14.25V9.55775H3.75V13.25Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                      Transport
                    </td>
                    <td>
                      {" "}
                      <span className="active_status">ACTIVE</span>
                    </td>
                    <td>₹74,880.00</td>
                  </tr>
                </thead>
              </table>
            </div>
            <div className="rates_table">
             
              <CommissionChart />
            </div>
          </div> */}

        <div className={styles.agent_dashboard_heading_sec}>
          <section className="agent_hotel_sidebar_new_btn">
            <div className="flex justify_content_between align_items_end">
              <div>
                <h4 className="text-left">Our Hotels</h4>
              </div>
            </div>
            {loader ? (
              <Loader size="4em" color="#009A50" />
            ) : (
              <div className="images-flex mt-10">
                {/* {!loader ? ( */}
                <Slider
                  {...hotelSettings}
                  className="new_agent_dashboard_slider"
                >
                  {allProperties &&
                    allProperties?.slice(0, 10)?.map((items, index) => {
                      const today = new Date(); // Today's date
                      const tomorrow = new Date();
                      tomorrow.setDate(today.getDate() + 1); // Tomorrow's date

                      const checkinDay = today.getDate();
                      const checkinMonth = today.getMonth() + 1; // Month is 0-indexed, so add 1
                      const checkinYear = today.getFullYear();

                      const checkoutDay = tomorrow.getDate();
                      const checkoutMonth = tomorrow.getMonth() + 1; // Month is 0-indexed, so add 1
                      const checkoutYear = tomorrow.getFullYear();

                      return (
                        <div
                          key={index}
                          onClick={() => {
                            scroll.scrollToTop({
                              duration: 500,
                              smooth: "easeInOutQuad",
                            });
                            navigate(`/vendor/property/edit/${items.id}`);
                            // navigate(
                            //   `/single-hotel-search/${items?.hotel_slug}?hotelId=${items?.hotel_id}&location=${items?.hotel_city}&room=1&adult=2&children=0&checkinDay=${checkinDay}&checkinMonth=${checkinMonth}&checkinYear=${checkinYear}&checkoutDay=${checkoutDay}&checkoutMonth=${checkoutMonth}&checkoutYear=${checkoutYear}`
                            // );
                          }}
                          // className="destination_link"
                          className={styles.hotel_card}
                        >
                          <div className={styles.img_sec}>
                            {items?.hotel_image &&
                            items?.hotel_image.length > 0 ? (
                              <img
                                src={items?.hotel_image[0]}
                                alt={items?.alt}
                              />
                            ) : (
                              <img src={imgNotFound} alt="image not found" />
                            )}
                          </div>

                          <div className={styles.content_sec}>
                            <div>
                              <span>
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask
                                    id="mask0_5983_7301"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="18"
                                    height="18"
                                  >
                                    <rect
                                      width="18"
                                      height="18"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_5983_7301)">
                                    <path
                                      d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                                      fill="#1C1B1F"
                                    />
                                  </g>
                                </svg>
                                {items.city}
                              </span>
                              <h4 className="text-capitalize"> {items.name}</h4>
                            </div>
                            <div>
                              <span
                                style={{ color: "#666666", textAlign: "end" }}
                              >
                                Starting From
                              </span>
                              <h3>
                                {formatIndianCurrency(items.starting_price)}
                              </h3>
                            </div>
                          </div>
                          {/* <div className="destination_name">
                        <div className="flex justify_content_between">
                          <div className="text-left">
                            <span className="text-left text-white">
                              {items.hotel_name}
                            </span>
                            <span className="font_11 block text-left text-white">
                              <svg
                                width="10"
                                height="12"
                                viewBox="0 0 10 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.00004 6.00008C5.32087 6.00008 5.59553 5.88585 5.824 5.65737C6.05247 5.4289 6.16671 5.15425 6.16671 4.83341C6.16671 4.51258 6.05247 4.23793 5.824 4.00946C5.59553 3.78098 5.32087 3.66675 5.00004 3.66675C4.67921 3.66675 4.40455 3.78098 4.17608 4.00946C3.94761 4.23793 3.83337 4.51258 3.83337 4.83341C3.83337 5.15425 3.94761 5.4289 4.17608 5.65737C4.40455 5.88585 4.67921 6.00008 5.00004 6.00008ZM5.00004 10.2876C6.18615 9.19869 7.06601 8.20946 7.63963 7.31987C8.21324 6.43029 8.50004 5.64036 8.50004 4.95008C8.50004 3.89036 8.16219 3.02265 7.4865 2.34696C6.8108 1.67126 5.98199 1.33341 5.00004 1.33341C4.0181 1.33341 3.18928 1.67126 2.51358 2.34696C1.83789 3.02265 1.50004 3.89036 1.50004 4.95008C1.50004 5.64036 1.78685 6.43029 2.36046 7.31987C2.93407 8.20946 3.81393 9.19869 5.00004 10.2876ZM5.00004 11.8334C3.43476 10.5015 2.26567 9.26432 1.49275 8.12196C0.719832 6.97959 0.333374 5.9223 0.333374 4.95008C0.333374 3.49175 0.802471 2.32994 1.74067 1.46466C2.67886 0.599387 3.76532 0.166748 5.00004 0.166748C6.23476 0.166748 7.32122 0.599387 8.25942 1.46466C9.19761 2.32994 9.66671 3.49175 9.66671 4.95008C9.66671 5.9223 9.28025 6.97959 8.50733 8.12196C7.73442 9.26432 6.56532 10.5015 5.00004 11.8334Z"
                                  fill="white"
                                />
                              </svg>
                              {items.hotel_city}
                            </span>
                          </div>
                          <div>
                            <span className="font_11">Starting From</span>
                            <h6>
                              {formatIndianCurrency(items.starting_price)}
                            </h6>
                          </div>
                        </div>
                      </div> */}
                        </div>
                      );
                    })}
                </Slider>
                {/* ) : (
                <Slider {...hotelListing}>
                  {Array.from({ length: 5 }).map((_, index) => {
                    return (
                      <Link
                        style={{ width: "33.33%" }}
                        className="destination_link"
                      >
                        <div>
                          <Skeleton height={300} />
                        </div>
                      </Link>
                    );
                  })}
                </Slider>
              )} */}
              </div>
            )}
          </section>
        </div>
      </div>
    </section>
  );
};

export default VendorDashboard;
